import { gql } from "@apollo/client";
import { DIGITAL_WALLET_INFO } from "../fragments";

export const USDT_LIST = gql`
  query digitalWallets($branch: ID) {
    digitalWallets(branch: $branch) {
      ...digitalWalletInfo
    }
  }
  ${DIGITAL_WALLET_INFO}
`;
